// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'

// These imports load individual services into the firebase namespace.
// import "firebase/auth"
import "firebase/auth"
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'



// Initialize Firebase
var firebaseConfig = {
    apiKey: "AIzaSyBa4pS22_nGAV3A6FV_9BZDcAS6we7l8zM",
    authDomain: "delivery-kiosk.firebaseapp.com",
    databaseURL: "https://delivery-kiosk.firebaseio.com",
    projectId: "delivery-kiosk",
    storageBucket: "delivery-kiosk.appspot.com",
    messagingSenderId: "920964870205",
    appId: "1:920964870205:web:e595c66a8fc474bb"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore()
export const auth = firebase.auth()
export const functions = firebase.functions()
export const storage = firebase.storage()